<template>
  <div>
    <div class="form-group">
      <label>ご希望の開催日をご選択ください</label>
      <ul class="checkblock-list">
        <li
          v-for="dateItem in dateList"
          :key="dateItem.id"
          class="checkblock-list-item"
        >
          <div
            class="checkblock"
            :class="dateClassNames(dateItem)"
            @click="onDateClick(dateItem.id)"
          >
            <input type="checkbox" :value="dateItem.id" />
            <div class="checkblock-label">
              <div class="space-between">
                <div class="text-paragraph">
                  <p
                    v-if="dateItem.event_description"
                    v-html="$domUtils.nl2br(dateItem.event_description)"
                    class="text-primary text-bold text-xxs"
                  />
                  <p>{{ dateItem.date | formatDateWeekDay }}</p>
                </div>
                <p class="text-danger text-xxxs">
                  残り{{ availableSets(dateItem) }}組様
                </p>
              </div>
            </div>
            <span class="checkblock-toggle" />
          </div>
        </li>
      </ul>
      <FormError :errors="errorDate"/>
    </div>
    <div class="form-group" v-if="eventDateId !== ''">
      <label for="start-time">ご希望の開始時間をご選択ください</label>
      <ul
        v-for="dateItem in dateList"
        :key="dateItem.id"
        v-show="eventDateId === dateItem.id"
        class="checkblock-list"
      >
        <li
          v-for="timeItem in dateItem.start_time_list"
          :key="timeItem.event_id"
          class="checkblock-list-item"
        >
          <div
            class="checkblock"
            :class="timeClassNames(timeItem)"
            @click="$emit('input', timeItem.event_id)"
          >
            <input type="checkbox" :value="timeItem.event_id" />
            <div class="checkblock-label">
              <div class="space-between">
                <p class="text-paragraph">
                  {{ timeItem.start_time | formatTime }}
                </p>
                <p class="text-danger text-xxxs">
                  残り{{ timeItem.available_sets }}組様
                </p>
              </div>
            </div>
            <span class="checkblock-toggle" />
          </div>
        </li>
      </ul>
      <FormError :errors="errorTime"/>
    </div>
  </div>
</template>

<script>
import FormError from '@/components/FormError.vue'
import { formatDateWeekDay } from '@/filters/format-date'
import formatTime from '@/filters/format-time'

export default {
  props: {
    dateList: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    errorDate: {
      type: Array,
      required: true,
    },
    errorTime: {
      type: Array,
      required: true,
    }
  },

  components: {
    FormError
  },

  filters: {
    formatDateWeekDay,
    formatTime,
  },

  data() {
    return {
      eventDateId: '',
    }
  },

  methods: {
    dateClassNames(dateItem) {
      return {
        'is-checked': this.isChecked(dateItem),
        'is-disabled': this.availableSets(dateItem) === 0,
      }
    },
    timeClassNames(timeItem) {
      return {
        'is-checked': timeItem.event_id === this.value,
        'is-disabled': timeItem.available_sets === 0,
      }
    },
    isChecked(dateItem) {
      return this.eventDateId === dateItem.id
    },
    availableSets(dateItem) {
      return dateItem.start_time_list.reduce((prev, current) => {
        return prev + current.available_sets
      }, 0)
    },
    onDateClick(val) {
      this.eventDateId = val
      this.$emit('input', 0)
      this.$emit('dateSelected')
    },
  }
}
</script>
